"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_edit_student_permit_controller_1 = __importDefault(require("./admin-edit-student-permit.controller"));
var admin_edit_student_permit_html_1 = __importDefault(require("./admin-edit-student-permit.html"));
function getPermit($stateParams, PermitModel) {
    return {};
}
getPermit.$inject = ["$stateParams", "PermitModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.permit", {
        url: "/permit",
        controller: admin_edit_student_permit_controller_1.default,
        controllerAs: "vm",
        resolve: {
            permitData: getPermit,
        },
        template: admin_edit_student_permit_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.permit", [])
    .config(config)
    .controller("AdminStudentViewPermitController", admin_edit_student_permit_controller_1.default);
